<mat-card class="dashboard-card mat-elevation-z8">
  <mat-card-header class="drag-handler">
    <mat-card-title>
      {{ title }}
      <button
        mat-icon-button
        class="more-button"
        [matMenuTriggerFor]="menu"
        aria-label="Toggle menu"
      >
        <mat-icon>open_width</mat-icon>
      </button>
      <button
        mat-icon-button
        class="more-button"
        [matMenuTriggerFor]="menu"
        aria-label="Toggle menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <button mat-menu-item>Move</button>
        <button mat-menu-item>Remove</button>
      </mat-menu>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="dashboard-card-content">
    <mat-spinner *ngIf="loading" class="dashboard-spinner"></mat-spinner>
    <ng-content *ngIf="!loading"></ng-content>
  </mat-card-content>
</mat-card>
